<template>
    <div>
        <div class="card shadow-sm">
            <div class="card-body">
                <h5 class="card-title">
                    {{ $t('pages.account.change_password.title') }}
                </h5>

                <form @submit.prevent="updatePassword">
                    <div class="form-group">
                        <label for="password">{{ $t('pages.account.change_password.password') }}</label>
                        <input type="password" class="form-control" id="password" :placeholder="$t('pages.account.change_password.password')"
                               v-model="password" :class="{'is-invalid': $errors.has('password')}">
                        <error input="password"/>
                    </div>
                    <div class="form-group">
                        <label for="password_confirmation">{{ $t('pages.account.change_password.password_confirm') }}</label>
                        <input type="password" class="form-control" id="password_confirmation" :placeholder="$t('pages.account.change_password.password_confirm')"
                               v-model="password_confirmation" :class="{'is-invalid': $errors.has('password_confirmation')}">
                        <error input="password_confirmation"/>

                        <button class="btn btn-outline-dark mt-4" >
                            {{ $t('pages.account.change_password.change_password') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AccountRepository from "../../../repositories/Account/AccountRepository";
export default {
    name: "ChangePassword",
    components: {PageHeader},
    data: () => ({
        password: '',
        password_confirmation: '',
    }),
    methods: {
        updatePassword() {
            AccountRepository.update({
                password: this.password,
                password_confirmation: this.password_confirmation,
            }).then(() => this.$router.push({name: 'account.info'}))
        }
    },
}
</script>

<style scoped>

</style>
